function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorrowFeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 315.766 277.624",
    style: {
      enableBackground: "new 0 0 315.766 277.624"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M300.972 62.704H59.715l-.001 16.305c0 2.062-2.374 3.22-3.999 1.951L32.333 62.704H14.822a3.241 3.241 0 0 0-3.242 3.242v147.028a3.241 3.241 0 0 0 3.242 3.242h241.257l.001-16.304c0-2.062 2.374-3.22 3.999-1.951l23.381 18.255h17.512a3.241 3.241 0 0 0 3.242-3.242V65.946a3.243 3.243 0 0 0-3.242-3.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M300.972 62.704h-20.31v79.88c0 34.162-27.694 61.855-61.855 61.855H11.58v8.534a3.241 3.241 0 0 0 3.242 3.242h241.257l.001-16.304c0-2.062 2.374-3.22 3.999-1.951l23.381 18.255h17.512a3.241 3.241 0 0 0 3.242-3.242V65.946a3.243 3.243 0 0 0-3.242-3.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d0aaf9"
    },
    d: "M268.511 84.082H47.283c0 7.912-6.414 14.326-14.326 14.326v82.106c7.912 0 14.326 6.414 14.326 14.326l221.228.001c0-7.912 6.414-14.326 14.326-14.326V98.408c-7.913 0-14.326-6.414-14.326-14.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M280.662 142.585c0 21.981-11.465 41.284-28.742 52.255h16.591c0-7.912 6.414-14.326 14.326-14.326V98.408c-.74 0-1.465-.056-2.175-.164v44.341z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#bd88ec"
    },
    cx: 157.897,
    cy: 139.461,
    r: 55.379
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#8d58c6"
    },
    d: "M170.159 85.445c11.969 10.158 19.564 25.312 19.564 42.24 0 30.585-24.794 55.379-55.379 55.379-4.214 0-8.318-.471-12.262-1.363 9.656 8.195 22.158 13.138 35.814 13.138 30.585 0 55.379-24.794 55.379-55.379 0-26.37-18.432-48.436-43.116-54.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M186.191 155.86c0-13.652-11.106-24.758-24.757-24.758h-7.075c-4.434 0-8.042-3.607-8.042-8.041s3.608-8.042 8.042-8.042h7.075a8.032 8.032 0 0 1 7.412 4.914 8.358 8.358 0 0 0 15.396-6.512 24.711 24.711 0 0 0-17.988-14.648V92.44a8.358 8.358 0 1 0-16.716 0v6.335c-11.352 2.25-19.937 12.284-19.937 24.286 0 13.651 11.106 24.757 24.758 24.757h7.075c4.434 0 8.041 3.608 8.041 8.042 0 4.434-3.607 8.041-8.041 8.041h-7.075a7.997 7.997 0 0 1-7.497-5.122 8.358 8.358 0 0 0-10.824-4.75 8.36 8.36 0 0 0-4.751 10.824c3.138 8.045 10.031 13.699 18.251 15.301v6.327a8.358 8.358 0 1 0 16.716 0v-6.335c11.353-2.249 19.937-12.284 19.937-24.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#8d58c6"
    },
    d: "M157.897 194.839a8.358 8.358 0 0 0 8.358-8.358v-6.335c11.352-2.25 19.937-12.284 19.937-24.286 0-2.251-.302-4.434-.868-6.508-6.493 15.256-19.633 27.002-35.785 31.6v5.528a8.358 8.358 0 0 0 8.358 8.359z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8d58c6"
    },
    cx: 247.719,
    cy: 139.755,
    r: 13.821
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8d58c6"
    },
    cx: 68.075,
    cy: 139.755,
    r: 13.821
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "m14.079 44.55 41.636-32.508c1.625-1.269 3.999-.111 3.999 1.951v16.325h170.432c17.887 0 32.387 14.5 32.387 32.387H59.715l-.001 16.305c0 2.062-2.374 3.22-3.999 1.951L14.079 48.452a2.474 2.474 0 0 1 0-3.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "m238.281 31.348.123.163c5.997 7.994.148 19.417-9.845 19.417H54.252c-6.739 0-12.202 5.463-12.202 12.201l-.001 7.16 13.665 10.67c1.625 1.269 3.999.111 3.999-1.951l.001-16.305h202.818c0-15.076-10.302-27.746-24.251-31.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "m301.715 234.372-41.636 32.508c-1.625 1.269-3.999.111-3.999-1.951v-16.325H85.648c-17.887 0-32.387-14.5-32.387-32.387h202.818l.001-16.305c0-2.062 2.374-3.22 3.999-1.951l41.636 32.508a2.477 2.477 0 0 1 0 3.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d58c6"
    },
    d: "M241.949 248.604c0-6.504-5.273-11.776-11.776-11.776H71.517c-4.551 0-8.882-.938-12.811-2.633 5.809 8.688 15.707 14.409 26.943 14.409h156.3zm59.766-18.135-12.108-9.453-35.334 27.588h1.807v16.325c0 2.062 2.374 3.22 3.999 1.951l41.636-32.508a2.477 2.477 0 0 0 0-3.903z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrowFeeIcon);
export default __webpack_public_path__ + "static/media/BorrowFeeIcon.f29025a9a4b2df2668299104847da860.svg";
export { ForwardRef as ReactComponent };